.customer-lead-step-layout__next-button {
  display: flex;
  flex-flow: row nowrap;
  justify-content: center;
  align-items: center;
}

@media screen and (width <= 640px) {
  .customer-lead-step-layout__next-button {
    padding: 24px 0;

    font-size: 24px;
  }
}

